import React from "react";
import HomePageOffers from "./HomePageOffers";
import Category from "./Category";
import RecentProducts from "./RecentProducts";
import TrendingProducts from "./TrendingProducts";
import ProductsLayout from "./ProductsLayout";

function HomeComponent() {
  return (
    <div className="bg-[#f0f0f0] min-h-screen overflow-x-hidden">
      <HomePageOffers />
      <Category />
      <div className="container mx-auto px-4 py-14 flex flex-col gap-14">
        <RecentProducts />
        <TrendingProducts />
        <ProductsLayout />
      </div>
    </div>
  );
}

export default HomeComponent;
